







import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Schedules, User } from '@/store';
import NewCurve from '@/pages/schedules/components/curves/NewCurve.vue';

@Component({ components: { NewCurve } })
class CreateCurve extends Vue {
  @User.State('project') project;
  @Schedules.Action('loadUserCurves') loadUserCurves;
  @Schedules.Action('loadSchedules') loadSchedules;

  loading = true;

  mounted() {
    this.load();
  }

  /*
    The existing curves are what the editor validates the new name against, and they are
    not loaded yet when this route is opened directly rather than from Curves Management.
    `loadSchedules` first, like the schedule flow does: the curves live in the project
    properties, and it is what pulls those in when they are missing.
  */
  @Watch('project')
  async load() {
    if (!this.project) return;
    this.loading = true;
    await this.loadSchedules({ projectId: this.project.id });
    await this.loadUserCurves();
    this.loading = false;
  }
}

export default CreateCurve;
